import React, { useState, useEffect } from 'react';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CentralCalls from '../../centralCalls';
import './WipTabs.css';
import { Auth } from 'aws-amplify';
import WipFiles from './WipFiles';

const WipNotes = ({ selectedLotOid }) => {
    const [userName, setUserName] = useState('');
    const [lotNotes, setLotNotes] = useState([]);
    const [newNote, setNewNote] = useState('');
    const [editNoteOid, setEditNoteOid] = useState(null);
    const [editNoteText, setEditNoteText] = useState('');

    const loadNotes = async () => {
        if (!selectedLotOid) {
            setLotNotes([]);
            return;
        }

        try {
            const notes = await CentralCalls.fetchTableData('lot_note', { lot_oid: selectedLotOid });
            setLotNotes(Array.isArray(notes) ? notes : []);
        } catch (error) {
            console.error('Failed loading notes', error);
            setLotNotes([]);
        }
    };

    useEffect(() => {
        loadNotes();
    }, [selectedLotOid]);

    const handleAddNote = async () => {
        if (!newNote.trim() || !selectedLotOid) {
            return;
        }

        const newNoteObj = {
            note: newNote.trim(),
            user: userName,
            note_date: new Date().toISOString(),
            lot_oid: selectedLotOid
        };

        const result = await CentralCalls.upsertData(newNoteObj, 'lot_note', 'insert');
        if (!result) {
            return;
        }

        setNewNote('');
        await loadNotes();
    };

    const handleEditNote = (oid) => {
        const noteToEdit = lotNotes.find(note => note.oid === oid);
        if (noteToEdit) {
            setEditNoteOid(oid);
            setEditNoteText(noteToEdit.note);
        }
    };

    const handleSaveNote = async (oid) => {
        if (!oid || !editNoteText.trim()) {
            return;
        }

        const result = await CentralCalls.upsertData({ oid: oid, note: editNoteText.trim() }, 'lot_note', 'update');
        if (!result) {
            return;
        }

        setEditNoteOid(null);
        setEditNoteText('');
        await loadNotes();
    };

    useEffect(() => {
        async function setUserInfo() {
            try {
                const user = await Auth.currentAuthenticatedUser();
                setUserName(user.attributes.email);
            } catch (error) {
                console.error('Error fetching user info', error);
            }
        }
        setUserInfo();
    }, []);

    return (
        <>
            {selectedLotOid ? (
                <div className="wip-notes-files-split">
                    <div className="wip-notes-panel">
                        <h2>Notes</h2>
                        <div className="notes-container">
                            <div className="add-note-container">
                                <input
                                    type="text"
                                    value={newNote}
                                    onChange={(e) => setNewNote(e.target.value)}
                                    placeholder="Enter your note here"
                                    className="note-input"
                                    maxLength="2000"
                                />
                                <button
                                    onClick={handleAddNote}
                                    disabled={!newNote.trim()}
                                    className="add-note-button"
                                >
                                    +
                                </button>
                            </div>
                            {lotNotes?.map((lotNote) => (
                                <div className="card" key={lotNote.oid}>
                                    <FontAwesomeIcon
                                        icon={faEdit}
                                        onClick={() => handleEditNote(lotNote.oid)}
                                        className="edit-note-icon"
                                    />
                                    {editNoteOid === lotNote.oid ? (
                                        <div>
                                            <input
                                                type="text"
                                                value={editNoteText}
                                                onChange={(e) => setEditNoteText(e.target.value)}
                                                className="note-input"
                                                maxLength="2000"
                                            />
                                            <button onClick={() => handleSaveNote(lotNote.oid)} className="save-note-button">
                                                Save
                                            </button>
                                        </div>
                                    ) : (
                                        <div>
                                            <p className="note-content">{lotNote.note}</p>
                                        </div>
                                    )}
                                    <p className="note-user">Posted by: {lotNote.user}</p>
                                    <p className="note-date">Date: {new Date(lotNote.note_date).toLocaleDateString()}</p>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* <div className="wip-files-panel">
                        <WipFiles selectedLotOid={selectedLotOid} showHeader={true} />
                    </div>  */}
                </div>
            ) : (
                <p>No notes available. Please select a lot.</p>
            )}
        </>
    );
}

export default WipNotes;
